// ANGULAR
import { Injectable } from '@angular/core';
import { HttpRequest, HttpHandler, HttpInterceptor } from '@angular/common/http';
// SERVICES
import { GlobalService } from '@services/global.service';
// MODELS
import { Backup } from '@models/backups.model';
// RXJS
import { Observable } from 'rxjs';

@Injectable()
export class AuthInterceptor implements HttpInterceptor {

  constructor(private globalService: GlobalService) { }

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<any> {
    const authToken: string | null = this.globalService.token;
    const backup: Backup | null = this.globalService.backupToPreview;

    const headers: Record<string, string> = {};

    if (authToken) { headers['Authorization'] = `Bearer ${authToken}`; }
    if (backup) { headers['Backup'] = new Date(backup.fecha).toString(); }

    // Clona la solicitud y agrega los encabezados
    const clonedRequest: HttpRequest<any> = request.clone({ setHeaders: headers });
    // Envía la solicitud clonada con el encabezado Authorization
    return next.handle(clonedRequest);
  }
}
